<template>
    <div>
        <router-link :to="url" class="active-rule-link">
            <span class="number">{{ number }}.</span> pravilo spletne higiene
        </router-link>
    </div>
</template>

<script>
	export default {
		name: "ActiveRuleLink",
		props: {
			url: {
				type: String,
				required: true,
			},
			number: {
				type: Number,
				required: true,
			},
		},
	}
</script>

<style lang="scss" scoped>
    @import "~bootstrap/scss/functions";
    @import "~bootstrap/scss/variables";
    @import "~bootstrap/scss/mixins";

    .active-rule-link {
        display: inline-flex;
        align-items: center;
        font-weight: 500;
        font-size: 1.3rem;
        color: #000000;

        @include media-breakpoint-up(md) {
            font-size: 1.5rem;
        }

        @include media-breakpoint-up(xl) {
            font-size: 2.2rem;
        }

        @include media-breakpoint-up(lg) {
            justify-content: center;
        }
    }

    .number {
        $size: 30px;

        display: inline-flex;
        width: $size;
        height: $size;
        margin-right: $size / 3;
        border-radius: 50%;
        align-items: center;
        justify-content: center;
        background: #000;
        color: #fff;

        @include media-breakpoint-up(lg) {
            $size: 45px;

            width: $size;
            height: $size;
            margin-right: $size / 3;
        }
    }
</style>